import React from 'react';

/** 建筑描边线条 SVG 组件 - 参照外高桥demo的多层发光效果 */
const BuildingLineBg: React.FC = () => {
  // 建筑线条路径数据
  const buildingPaths = [
    'M1792 757.272727 L1375 933.636364 L1220 840.909091',
    'M1810.5 820.5 L1379 1002.63636 L1224 909.909091',
    'M1637 571.318182 L2115.18182 856.318182 L2285.86364 784.5',
    'M1634.5 343.5 L2115.18182 629.318182 L2283 557',
    'M700 873.136364 L832.727273 952 L1389.31818 718.363636 L1389.31818 712.227273 L1375.90909 704.272727',
    'M700 670.136364 L832.727273 749 L1389.31818 515.363636 L1389.31818 509.227273 L1375.90909 501.272727',
    'M705 466 L831.727273 541 L1374 312 L1374 305.863636',
  ];

  // 每条线的动画延迟时间
  const delays = [0, 0.6, 1.2, 1.8, 0.4, 1.0, 1.6];

  return (
    <svg
      viewBox="0 0 2970 1080"
      preserveAspectRatio="xMidYMid slice"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: '100%', height: '100%' }}
    >
      <defs>
        {/* 普通发光滤镜 */}
        <filter id="building-glow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur in="SourceGraphic" stdDeviation="2" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        {/* 强发光滤镜 */}
        <filter id="building-glow-strong" x="-80%" y="-80%" width="260%" height="260%">
          <feGaussianBlur in="SourceGraphic" stdDeviation="4" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        {/* 样式定义 */}
        <style>
          {`
            .building-line-base {
              fill: none;
              stroke: #7DC6FF;
              stroke-width: 1.5;
              stroke-linecap: round;
              stroke-linejoin: round;
              opacity: 0.35;
              filter: url(#building-glow);
            }
            .building-line-pulse-glow {
              fill: none;
              stroke-linecap: round;
              stroke-linejoin: round;
              stroke: #7DC6FF;
              stroke-width: 6;
              stroke-dasharray: 0.08 0.92;
              stroke-dashoffset: 1;
              opacity: 0.5;
              filter: url(#building-glow-strong);
              animation: buildingEnergy 4s linear infinite;
            }
            .building-line-pulse-core {
              fill: none;
              stroke-linecap: round;
              stroke-linejoin: round;
              stroke: #e8fdff;
              stroke-width: 2.5;
              stroke-dasharray: 0.08 0.92;
              stroke-dashoffset: 1;
              opacity: 1;
              filter: url(#building-glow);
              animation: buildingEnergy 4s linear infinite;
            }
            .building-line-pulse-delay {
              fill: none;
              stroke-linecap: round;
              stroke-linejoin: round;
              stroke: #7DC6FF;
              stroke-width: 5;
              stroke-dasharray: 0.05 0.95;
              stroke-dashoffset: 1;
              opacity: 0.25;
              filter: url(#building-glow-strong);
              animation: buildingEnergy 4s linear infinite;
            }
            @keyframes buildingEnergy {
              from { stroke-dashoffset: 1; }
              to { stroke-dashoffset: 0; }
            }
          `}
        </style>
      </defs>

      {/* 渲染所有建筑线条 */}
      {buildingPaths.map((path, index) => (
        <g key={index}>
          {/* 底层静态路径 */}
          <path className="building-line-base" d={path} pathLength="1" />
          {/* 外层发光 */}
          <path
            className="building-line-pulse-glow"
            d={path}
            pathLength="1"
            style={{ animationDelay: `${delays[index]}s` }}
          />
          {/* 核心亮线 */}
          <path
            className="building-line-pulse-core"
            d={path}
            pathLength="1"
            style={{ animationDelay: `${delays[index]}s` }}
          />
          {/* 延迟跟随 */}
          <path
            className="building-line-pulse-delay"
            d={path}
            pathLength="1"
            style={{ animationDelay: `${delays[index] + 1.6}s` }}
          />
        </g>
      ))}
    </svg>
  );
};

export default BuildingLineBg;
